import { Input } from 'grab-ui';
import React, { Component } from 'react';
import CampaignCodeCorrect from 'img/ucd_campaign_code_right.svg';

export const CAMPAIGN_CODE_MODES = {
  auto: 'auto',
  manual: 'manual',
};

type Props = {
  initialMode: string, // 'auto' or 'manual', default to auto
  initialCode: string, // only used upon component construction
  autoGeneratedCode: string, // dynamic input, CampaignCodeGeneratedFormItem will call onCodeChange upon value change
  onCodeChange: Function, // a callback function that takes code as input
  onModeChange: Function,
};

export default class CampaignCodeGeneratedFormItem extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      mode: props.initialMode,
      code: props.initialCode,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    const { mode } = this.state;
    if (
      nextProps.autoGeneratedCode !== this.props.autoGeneratedCode &&
      mode === CAMPAIGN_CODE_MODES.auto
    ) {
      this.props.onCodeChange(nextProps.autoGeneratedCode);
    }
  }

  render() {
    const { mode, code } = this.state;
    const { autoGeneratedCode, onCodeChange, onModeChange } = this.props;

    return (
      <React.Fragment>
        {mode === CAMPAIGN_CODE_MODES.auto ? (
          <div>
            <div
              style={{
                height: '48px',
                width: '100%',
                background: '#F3F6FB',
                borderRadius: '4px',
                padding: '14px 16px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div>{autoGeneratedCode}</div>
              <div style={{ fontSize: '18px', fontWeight: 'bolder' }}>
                <img src={CampaignCodeCorrect} height={'18px'} width={'18px'} alt={''} />
              </div>
            </div>
            <div
              style={{
                color: '#136FD8',
                cursor: 'pointer',
                marginTop: '11px',
                fontWeight: '600',
              }}
              onClick={() => {
                if (onModeChange) {
                  onModeChange(CAMPAIGN_CODE_MODES.manual);
                }
                this.setState({
                  mode: CAMPAIGN_CODE_MODES.manual,
                  code: '',
                });
                onCodeChange('');
              }}
            >
              Change campaign code
            </div>
          </div>
        ) : (
          <div>
            <Input
              onChange={e => {
                this.setState({
                  code: e.target.value,
                });
                onCodeChange(e.target.value);
              }}
              value={code}
              placeholder={'Enter your custom code'}
            />
            <div
              style={{
                color: '#136FD8',
                cursor: 'pointer',
                marginTop: '11px',
                fontWeight: '600',
              }}
              onClick={() => {
                if (onModeChange) {
                  onModeChange(CAMPAIGN_CODE_MODES.auto);
                }
                this.setState({
                  mode: CAMPAIGN_CODE_MODES.auto,
                  code: autoGeneratedCode,
                });
                onCodeChange(autoGeneratedCode);
              }}
            >
              Change back to generated code
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
